import "@ionic/react/css/core.css";
import "@ionic/react/css/ionic.bundle.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import ReactDOM from "react-dom/client";
import "./i18n/i18n";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { NextUIProvider } from "@nextui-org/react";
import MainApplication from "./MainComp";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <NextUIProvider>
    <MainApplication />
  </NextUIProvider>
  // <React.StrictMode>
  //   <MainApplication />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
